<template lang="pug">
.reserve-page
  .main-title
    .person
      .person-fullName
        .firstName Hello {{ $root.member.user_name }}
        .lastName {{ $root.member.name }}
      .person-avatar
        img.user-pic(:src="$root.member.user_picture", alt="alt")
    p 歡迎預約
    .notes-content
      p.notes-title 備註
        //- span （必填欄位，若無則寫無）
    textarea.textarea-box(
      v-model="note_text"
      :class="{on_focus: input_focus}"
      rows="5"
      cols="30"
      @focus="input_focus = true"
      @blur="input_focus = false"
      :placeholder="'請填寫特殊情況及需求。例如：嬰兒車、包車行程、導遊......等'"
    )

  .button-group
    button.stepUp(type="button" @click="$router.go(-1)") 
      .step-txt 上一步
    button.active.stepNext(type="button" @click="appointmentSuccess") 
      .step-txt 完成預約

  .succ-appointment(v-if="isShow")
    .succ-content
      img(src="../assets/images/icon_ok.svg" alt="alt")
      p 預約成功
</template>

<script>
import Vue from "vue";
import { Calendar } from "vant";

Vue.use(Calendar);

export default {
  name: "reserve-page",
  components: {},
  data () {
    return {
      regingStatus: false,
      note_text: '',
      input_focus: false,
      isShow: false
    };
  },
  mounted () { },
  methods: {
    appointmentSuccess () {
      if (this.regingStatus) {
        return
      }

      this.regingStatus = true
      this.$root.register.note = this.note_text
      this.sendRegisterData()
    },
    sendRegisterData () {
      let vm = this
      this.$root.apis.reserveOrder({
        userId: this.$root.member.user_lineId,
        userName: this.$root.member.user_name,
        register: this.$root.register
      }, function () {
        vm.isShow = true
        setTimeout(() => { vm.$root.goPage('/member-center') }, 3000)
      })
    }
  },
};
</script>
<style lang="sass" scoped>
.reserve-page
  padding: 48px 35px 150px
  height: 100%
  overflow: auto
  .main-title
    .person
      display: flex
      justify-content: space-between
      align-items: center
      .person-fullName
        font-size: 32px
        font-weight: 700
        line-height: 2ex
        color: #fff
      .person-avatar
        width: 50px
        img
          width: 100%
          vertical-align: middle
    p
      font-size: 24px
      font-weight: 400
      color: #fff
      // padding-top: 13px
    .notes-title
      font-size: 18px
      font-weight: 400
      margin-top: 37px
      color: #898A8D
      span
        color: #D10E2F
    .textarea-box
      width: 100%
      border: 1.5px solid #505251
      border-radius: 10px
      margin-top: 25px
      &.on_focus
        border: 1.5px solid #22F48F
    .textarea-box[placeholder]
      font-size: 20px
      font-weight: 400
      color: #fff
    
  .button-choose
    display: flex
    align-items: center
    gap: 12px
    padding: 7px
    border-radius: 10px
    background-color: #1E1E1E
    .stepHour,.stepDay,.frequency
      width: 160px
      border-radius: 5px
      border: none
      &.active
        background: #22F48F
        .step-txt
          color: #000
      .step-txt
        font-size: 18px
        font-weight: 700
        color: #898a8d
  .alculation-list
    display: flex
    justify-content: space-between
    .alculation-item
      .alculation-title
        font-size: 18px
        font-weight: 700
        color: #898A8D
      .alculation-content
        font-size: 32px
        color: #22F48F
      .special-type
        text-align: right
  .typesettin-unit
    .typesettin-item
      .unit-title
        font-size: 18px
        font-weight: 700
        color: #898A8D
        padding: 20px 0px
      .unit-content
        font-size: 32px
        color: #22F48F
        line-height: 2ex
  .button-group
    padding-top: 15%
    display: flex
    .stepUp
      width: 40vmin
      margin: auto
      border-radius: 12.5vmin
      background-color: #fff
      border: none
      padding: 3vmin 0px
    .stepNext
      width: 40vmin
      margin: auto
      border-radius: 12.5vmin
      background-color: #898A8D
      border: none
      padding: 3vmin 0px
      &.active
        background-color: #22F48F
    .step-txt
      text-align: center
      font-size: 6vmin
      font-weight: 700
      color: #1E1E1E
  .succ-appointment
    width: 100%
    height: 100vh
    position: fixed 
    top: 0
    left: 0
    background: rgba(0,0,0,.7)
    .succ-content
      width: 180px
      padding: 38px 42px 31px
      border-radius: 5px
      border: 2px solid #505251
      position: absolute 
      top: 50%
      left: 50%
      transform: translate(-50%,-50%)
      background-color: #151516
      p
        font-size:  clamp(22px, 5.1vw, 24px)
        font-weight: 500
        color: #22F48F
        margin-top: 16px
</style>
